import React from 'react';
import cnames from 'classnames';
import ReactLinkpiles from '@homeaway/react-linkpile';
import { FormattedMessage } from '../Intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './Linkpiles.less';

const CNAME = 'Linkpiles';

const Linkpiles = ({ linkpiles, isTouchDevice }) => {
  const hideTabs = linkpiles.length === 1;

  return !!linkpiles.length && (
    <section className="Content__section">
      <div className={`row ${CNAME}__row`}>
        <div className={cnames(`${CNAME}__container`, {
          'col-xs-12': isTouchDevice,
          'col-xs-offset-1 col-xs-10': !isTouchDevice,
          'tabless-linkpile': hideTabs
        })}
        >
          <h2 className={cnames(`${CNAME}__title`)}>
            <FormattedMessage id={'component.linkpile.heading'} />
          </h2>
          <ReactLinkpiles
            tabs={linkpiles}
            hideTabs={hideTabs}
          />
        </div>
      </div>
    </section>
  );
};

const mapStateToProps = ({
  content: { linkpiles },
  system: { isTouchDevice }
}) => ({
  linkpiles,
  isTouchDevice
});

export default connect(mapStateToProps, null)(Linkpiles);

Linkpiles.propTypes = {
  linkpiles: PropTypes.arrayOf(PropTypes.object).isRequired,
  isTouchDevice: PropTypes.bool
};

Linkpiles.defaultProps = {
  linkpiles: [],
  isTouchDevice: false
};
